import { create } from 'zustand'
import { UserPermissionsStore } from './UserPermissionsStore.types'

const useUserPermissionsStore = create<UserPermissionsStore>((set, get) => ({
  userPermissions: null,
  checkPermission: (type, permissionId) => {
    const { userPermissions } = get()
    return Boolean(userPermissions?.[type]?.find(item => item === permissionId))
  },
  checkPermissionByDescription: description => {
    const { userPermissions } = get()
    return Boolean(
      userPermissions?.actionsDescriptions?.some(item => item === description),
    )
  },
  updateValue(key, value) {
    set(state => ({
      ...state,
      [key]: value,
    }))
  },
}))

export default useUserPermissionsStore
